import { useState, useEffect, useRef } from "react";
import { ErrorCard, LoadingCard, MainContainer, MasterGrid } from "../../components";
import { Button, Input, Card, CardBody, Autocomplete, AutocompleteItem, Textarea, Tab, Tabs } from "@heroui/react";
import { usePost, useFetchWithBody } from "../../api/reactQueryCustomHooks";
import { apiRoute, ENUM_INPUT_TYPE, linksUrl } from "../../constants/enum";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { resetDetailParams } from "../../state/itemTypeEntrySlice";
import { faCancel, faFile, faSave } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers"
import dayjs from "dayjs"
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"
import { useModalToast } from "../../components/modalToast/ModalToastContext"
import AutoCompleteInput from "../../components/AutoCompleteInput";
import { addDays } from "date-fns";
import { daysInWeek } from "date-fns/constants";

const ExportDetailEntry = ({ detailParam }) => {

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { user } = useSelector((state) => state.auth);
    const { startDate, endDate, compCode } = useSelector((state) => state.company);
    const submitLockRef = useRef(false);//
    const { show } = useModalToast();
    const [selTabKey, setSelTabKey] = useState("export")

    const { isError: isErrorDetail, data: detail = [], mutate: funGetDetail } = usePost({
        url: apiRoute.invoiceEntry.fetchEntryDetail,
        queryKey: "fetchInvoiceDetail",
    });
    console.log(detail, "inv",detailParam)
    useEffect(() => {
        if (detailParam && Object.keys(detailParam).length > 0) {
            const { comp_code, transaction_id, bill_type, trade_of } = detailParam

            funGetDetail({
                data: {
                    compcode: comp_code,
                    transactionid: transaction_id,
                    billtype: bill_type,
                    tradeof: trade_of
                }
            })
        }
    }, [detailParam])
    const formField = {
        billDate: "billDate",
        shipmentNo: "shipmentNo",
        shipmentDate: "shipmentDate",
        portCode: "portCode",
        portLoading: "portLoading",
        portDischarge: "portDischarge",
        placePreCarr: "placePreCarr",
        preCarrBy: "preCarrBy",
        finDestination: "finDestination",
        cntryOriginGood: "cntryOriginGood",
        vessNo: "vessNo",
        courier: "courier",
        cntryFinDestination: "cntryFinDestination",
        customAgent: "customAgent",
        distOriginGood: "distOriginGood",
        stateOriginGood: "stateOriginGood",
        insureBy: "insureBy",
        epcgLicNo: "epcgLicNo",
        narration: "narration",
        signatoryName: "signatoryName",
        poNo: "poNo",
        poDate: "poDate:",
        lrNo: "lrNo",
        lrDate: "lrDate",
        cases: "cases",
        eWeight: "eWeight",
        termId: "termId",
        dueDaysBank: "dueDaysBank",
        dueDate: "dueDate",
        dueDays: 'dueDays',
        bankDueDate: "bankDueDate"




    }
    const minAllowedDate = dayjs(startDate)
    const maxAllowedDate = dayjs(endDate)

    const emptyFormField = Object.keys(formField).reduce((acc, key) => {
        const today = dayjs();
        if ([formField.shipmentDate, formField.lrDate, formField.dueDate, formField.bankDueDate].includes(key))
            acc[key] = null
        else if ([formField.eWeight, formField.dueDaysBank].includes(key))
            acc[key] = 0
        else acc[key] = ""
        return acc
    }, {})
    const [formData, setFormData] = useState({
        ...emptyFormField

    });
    const { isError: isErrorMast, isLoading, data: mastetData = [], } = useFetchWithBody({
        url: apiRoute.invoiceEntry.getExportParams,
        queryKey: "fetchExportMasterData",
        inputData: {

        }
    })
     const {   data: termData = [], } = useFetchWithBody({
        url: apiRoute.invoiceEntry.getTermMasterData,
        queryKey: "fetchExportTermMasterData",
        inputData: {

        }
    })
    console.log(termData,"tt")
    const FnformatDate = (date) => {
        if (!date || dayjs(date).format("YYYY-MM-DD") === "1900-01-01") {
            return null;
        }

        return dayjs(date).format("YYYY-MM-DD");
    };
    useEffect(() => {
        if (detail && Object.keys(detail).length > 0) {
            if (detail?.itemData && detail?.itemData?.length > 0) {
                const expdetail = detail?.itemData[0]
                setFormData({
                    [formField.billDate]: dayjs(expdetail?.Bill_Date).format("YYYY-MM-DD") || null,
                    [formField.shipmentNo]: expdetail?.Shipment_No || '',
                    [formField.shipmentDate]: FnformatDate(expdetail?.Shipment_Date) || null,
                    [formField.portCode]: expdetail?.Port_Code || '',
                    [formField.portLoading]: expdetail?.PortLoding || '',
                    [formField.portDischarge]: expdetail?.PortDischarge || '',
                    [formField.placePreCarr]: expdetail?.PlacePreCarr || '',
                    [formField.preCarrBy]: expdetail?.PreCarrBy || '',
                    [formField.finDestination]: expdetail?.FinDestination || '',
                    [formField.cntryOriginGood]: expdetail?.CntryOrgin_Good || '',
                    [formField.vessNo]: expdetail?.VessNo || '',
                    [formField.courier]: expdetail?.Courier || '',
                    [formField.cntryFinDestination]: expdetail?.Cntry_FinDestination || '',
                    [formField.customAgent]: expdetail?.Cutom_Agent || '',
                    [formField.distOriginGood]: expdetail?.Dist_Origin_Good || '',
                    [formField.stateOriginGood]: expdetail?.State_Origin_Good || '',
                    [formField.insureBy]: expdetail?.Insure_By || '',
                    [formField.epcgLicNo]: expdetail?.EpcgLicNo || '',
                    [formField.narration]: expdetail?.Narration || '',
                    [formField.signatoryName]: expdetail?.Signatory_Name || '',
                    [formField.poNo]: expdetail?.PoNo || '',
                    [formField.poDate]: FnformatDate(expdetail?.PoDate) || null,
                    [formField.lrNo]: expdetail?.Lr_No || '',
                    [formField.lrDate]: FnformatDate(expdetail?.LR_Date) || '',
                    [formField.cases]: expdetail?.Cases || '',
                    [formField.eWeight]: expdetail?.EWeight || null,
                    [formField.termId]: expdetail?.Term_Id || '',
                    [formField.dueDaysBank]: expdetail?.DueDayes_Bank || '',
                    [formField.dueDate]: expdetail?.Due_Date || null,
                    [formField.dueDays]: expdetail?.DueDays || '',
                    [formField.bankDueDate]: expdetail?.Bank_Due_Date || null
                })
            }
        }
    }, [detail])



    console.log(formData)
    const handleChange = (e) => {
        const { name, value } = e.target
        let t_bankdueDate = formData[formField.bankDueDate]
        let t_dueDate = formData[formField.dueDate]
        if (name == formField.dueDaysBank) {
            if (formData[formField.billDate] && formData[formField.billDate] != ""
                && formData[formField.billDate] != "Invalid Date" && value != "") {
                t_bankdueDate = dayjs(addDays(formData[formField.billDate], Number(value))).format("YYYY-MM-DD")
                //console.log(t_bankdueDate)
            }
        }
        else if (name == formField.dueDays) {
            if (formData[formField.billDate] && formData[formField.billDate] != ""
                && formData[formField.billDate] != "Invalid Date" && value != "") {
                t_dueDate = dayjs(addDays(formData[formField.billDate], Number(value))).format("YYYY-MM-DD")
                /// console.log(t_bankdueDate)
            }
        }
        setFormData({ ...formData, [name]: value, [formField.bankDueDate]: t_bankdueDate, [formField.dueDate]: t_dueDate });
    };

    const { mutate: funAddUpdate, isPending, isError } = usePost({
        queryKey: "ItemTypeAddUpdate",
        url: apiRoute.invoiceEntry.updateExportData,
        onSuccessTasks: (data) => {
            show("Export Details Saved")
            //    navigate(linksUrl.master.itemType.itemTypeMaster);

        },
    });

    console.log(formData, "f")
    const inputBoxes = {
        Row1: [
            {
                id: formField.shipmentNo,
                name: formField.shipmentNo,
                placeholder: "Ship No.",
                type: ENUM_INPUT_TYPE.text,
                size: "sm",
                label: "",
                isrequired: false,
            },
            {
                id: formField.shipmentDate,
                name: formField.shipmentDate,
                placeholder: " Ship Date",
                type: ENUM_INPUT_TYPE.date,
                size: "sm",
                label: "",
                isrequired: false,
            },
            {
                id: formField.portCode,
                name: formField.portCode,
                placeholder: "Port Code.",
                type: ENUM_INPUT_TYPE.text,
                size: "sm",
                label: "",
                isrequired: false,
            },


        ],
        Row2: [

            {
                id: formField.portLoading,
                name: formField.portLoading,
                placeholder: "Port Of Loading",
                type: ENUM_INPUT_TYPE.inputlist,
                size: "sm",
                label: "",
                data: mastetData?.portLoadMst || [],
                itemkey: "PortLoding",
                itemvalue: "PortLoding",
                isrequired: false,
            },
            {
                id: formField.portDischarge,
                name: formField.portDischarge,
                placeholder: "Port Of Discharge",
                type: ENUM_INPUT_TYPE.inputlist,
                size: "sm",
                label: "",
                data: mastetData?.portDischMst || [],
                itemkey: "PortDischarge",
                itemvalue: "PortDischarge",
                isrequired: false,
            },
            {
                id: formField.placePreCarr,
                name: formField.placePreCarr,
                placeholder: "Place Of Rec, By Pre-Carrier",
                type: ENUM_INPUT_TYPE.inputlist,
                size: "sm",
                label: "",
                data: mastetData?.placeCarrMst || [],
                itemkey: "PlacePreCarr",
                itemvalue: "PlacePreCarr",
                isrequired: true,
            },

        ],
        Row3: [
            {
                id: formField.preCarrBy,
                name: formField.preCarrBy,
                placeholder: "Pre Carrieage By",
                type: ENUM_INPUT_TYPE.inputlist,
                size: "sm",
                label: "",
                data: mastetData?.preCarrByMst || [],
                itemkey: "PreCarrBy",
                itemvalue: "PreCarrBy",
                isrequired: false,
            },
            {
                id: formField.finDestination,
                name: formField.finDestination,
                placeholder: "Final Destination",
                type: ENUM_INPUT_TYPE.inputlist,
                size: "sm",
                label: "",
                data: mastetData?.finDestMst || [],
                itemkey: "FinDestination",
                itemvalue: "FinDestination",
                isrequired: false,
            },
            {
                id: formField.cntryOriginGood,
                name: formField.cntryOriginGood,
                placeholder: "Country Of Origin Goods",
                type: ENUM_INPUT_TYPE.inputlist,
                size: "sm",
                label: "",
                data: mastetData?.cntryOrgnMst || [],
                itemkey: "CntryOrgin_Good",
                itemvalue: "CntryOrgin_Good",
                isrequired: true,
            },
        ],
        Row4: [
            {
                id: formField.vessNo,
                name: formField.vessNo,
                placeholder: "Vessels /Flight No",
                type: ENUM_INPUT_TYPE.inputlist,
                size: "sm",
                label: "",
                data: mastetData?.vesselMst || [],
                itemkey: "VessNo",
                itemvalue: "VessNo",
                isrequired: false,
            },
            {
                id: formField.courier,
                name: formField.courier,
                placeholder: "Courier",
                type: ENUM_INPUT_TYPE.inputlist,
                size: "sm",
                label: "",
                data: mastetData?.courierMst || [],
                itemkey: "Courier",
                itemvalue: "Courier",
                isrequired: false,
            },
            {
                id: formField.cntryFinDestination,
                name: formField.cntryFinDestination,
                placeholder: "Country of Final Destination",
                type: ENUM_INPUT_TYPE.inputlist,
                size: "sm",
                label: "",
                data: mastetData?.cntryFinDestMst || [],
                itemkey: "Cntry_FinDestination",
                itemvalue: "Cntry_FinDestination",
                isrequired: false,
            },

        ],
        Row5: [
            {
                id: formField.customAgent,
                name: formField.customAgent,
                placeholder: "Custom Agent",
                type: ENUM_INPUT_TYPE.inputlist,
                size: "sm",
                label: "",
                data: mastetData?.custAgntMst || [],
                itemkey: "Cutom_Agent",
                itemvalue: "Cutom_Agent",
                isrequired: false,
            },
            {
                id: formField.distOriginGood,
                name: formField.distOriginGood,
                placeholder: "Dist of Origin Good",
                type: ENUM_INPUT_TYPE.inputlist,
                size: "sm",
                label: "",
                data: mastetData?.distOrgGoodMst || [],
                itemkey: "Dist_Origin_Good",
                itemvalue: "Dist_Origin_Good",
                isrequired: false,
            },
            {
                id: formField.stateOriginGood,
                name: formField.stateOriginGood,
                placeholder: "State Of Origin Good",
                type: ENUM_INPUT_TYPE.inputlist,
                size: "sm",
                label: "",
                data: mastetData?.stateOrgGoodMst || [],
                itemkey: "State_Origin_Good",
                itemvalue: "State_Origin_Good",
                isrequired: true,
            },
        ],
        Row6: [
            {
                id: formField.epcgLicNo,
                name: formField.epcgLicNo,
                placeholder: "EPCG Lic No.",
                type: ENUM_INPUT_TYPE.inputlist,
                size: "sm",
                label: "",
                data: mastetData?.epcgLicMst || [],
                itemkey: "EpcgLicNo",
                itemvalue: "EpcgLicNo",
                isrequired: false,
            },
            {
                id: formField.insureBy,
                name: formField.insureBy,
                placeholder: "Insured By",
                type: ENUM_INPUT_TYPE.inputlist,
                size: "sm",
                label: "",
                data: mastetData?.insuredMst || [],
                itemkey: "Insure_By",
                itemvalue: "Insure_By",
                isrequired: false,
            },
            {
                id: formField.signatoryName,
                name: formField.signatoryName,
                placeholder: "Invoice Signatory By",
                type: ENUM_INPUT_TYPE.inputlist,
                size: "sm",
                label: "",

                isrequired: false,
            },
        ],

    }
    const miscInputBoxes = {
        Row1: [
            {
                id: formField.poNo,
                name: formField.poNo,
                placeholder: "Po No.",
                type: ENUM_INPUT_TYPE.text,
                size: "sm",
                label: "",
                isrequired: false,
            },
            {
                id: formField.poDate,
                name: formField.poDate,
                placeholder: " Po Date",
                type: ENUM_INPUT_TYPE.date,
                size: "sm",
                label: "",
                isrequired: false,
            },

        ],
        Row2: [

            {
                id: formField.termId,
                name: formField.termId,
                placeholder: "Term Id",
                type: ENUM_INPUT_TYPE.autocomplete,
                size: "sm",
                label: "",
                data:  termData||[],
                itemkey: "Term_Id",
                itemvalue: "Term_Desc",
                isrequired: false,
            },],
        Row3: [
            {
                id: formField.dueDaysBank,
                name: formField.dueDaysBank,
                placeholder: "Bank Due Days",
                type: ENUM_INPUT_TYPE.text,
                size: "sm",
                label: "",
                isrequired: false,
            },
            {
                id: formField.bankDueDate,
                name: formField.bankDueDate,
                placeholder: "Bank Due Date",
                type: ENUM_INPUT_TYPE.date,
                size: "sm",
                label: "",
                isrequired: false,
            },
        ],
        // Row4: [
        //     {
        //         id: formField.dueDays,
        //         name: formField.dueDays,
        //         placeholder: "Due Days",
        //         type: ENUM_INPUT_TYPE.text,
        //         size: "sm",
        //         label: "",
        //         isrequired: false,
        //     },
        //     {
        //         id: formField.dueDate,
        //         name: formField.dueDate,
        //         placeholder: "Due Date",
        //         type: ENUM_INPUT_TYPE.date,
        //         size: "sm",
        //         label: "",
        //         isrequired: false,
        //     },


        // ],


    }
    const handleAutoCompleteChange = (value, rowid, name) => {

        setFormData({
            ...formData,
            [name]: value,
        })

    }
    const hanldeBlur = (index, e, id) => { }
    const handleDateBlur = (e, name) => {
        const input = e.target.value.trim();   // "DD/MM/YYYY"

        if (!input) return;

        // Parse typed date strictly as DD/MM/YYYY
        const parsed = dayjs(input, "DD/MM/YYYY", true);

        // ❌ Invalid format or wrong date typed
        if (!parsed.isValid()) {
            show("Invalid date format. Use DD/MM/YYYY")
            // toast.error("Invalid date format. Use DD/MM/YYYY", {
            //     position: "top-center",
            //     className: "toast-error"
            // });
            return;
        }


        // Convert to API format
        const formatted = parsed.format("YYYY-MM-DD");


        setFormData(prev => {
            const updated = { ...prev, [name]: formatted };
            return updated;
        });

    };
    const [errors, setErrors] = useState({})
    const validateForm = () => {
        const newErrors = {}

        // Validate username
        if (formData.vouNo.trim() == "") {
            newErrors[formField.shipmentNo] = "Shipment No required"
        }


        if (formData[formField.shipmentDate] == null || formData[formField.shipmentDate] == "" || formData[formField.shipmentDate] == "Invalid Date") {
            newErrors[formField.challanDate] = "Shipment Date required"
        }
        setErrors(newErrors)
        // Return true if there are no errors
        return Object.keys(newErrors).length === 0
    }

    const handleSubmit = (e) => {
        e.preventDefault();

        //   if (submitLockRef.current) return;
        //  submitLockRef.current = true;

        const { comp_code, transaction_id, bill_type, trade_of } = detailParam
        
        if (![comp_code, transaction_id, bill_type, trade_of].every(
            value => value !== null && value !== undefined && String(value).trim() !== ''
        )) {
            show("Bill Details Not Found");
            return;
        }
        funAddUpdate({
            data: {
                comp_code: compCode.join(","),
                bill_type: bill_type,
                transaction_id: transaction_id,
                trade_of: trade_of,
                bill_no: "",
                export_data: formData,
            }
        });

    };



    if (isPending) return <LoadingCard />;
    if (isError) return <ErrorCard />;

    return (
        <div>
            <Card className="p-2">
                <CardBody>
                    <form onSubmit={handleSubmit}>
                        <Tabs
                            color="primary"
                            selectedKey={selTabKey}
                            onSelectionChange={setSelTabKey}
                            radius="lg"
                            variant="solid"
                            classNames={{
                                base: "w-full",

                                tabList:
                                    "w-full bg-stone-100 p-1.5 rounded-xl border border-stone-200 shadow-sm gap-1",

                                tab:
                                    "px-6 py-2.5 h-9 rounded-lg font-medium text-stone-600 text-sm " +
                                    "transition-all duration-200 hover:bg-white hover:text-orange-700 " +
                                    "data-[selected=true]:text-white data-[selected=true]:font-semibold",

                                cursor:
                                    "bg-gradient-to-r from-orange-400 to-orange-500 rounded-lg " +
                                    "shadow-md shadow-orange-200",

                                tabContent:
                                    "group-data-[selected=true]:text-white uppercase text-sm font-semibold",

                                panel: "pt-5",
                            }}
                        >
                            <Tab key="export" title="Export Detail">
                                {
                                    Object.keys(inputBoxes).map((key, ind) => (
                                        <div key={`item-${ind}`}>
                                            {/* ${isMobile ? 'flex-wrap' : ''} */}
                                            <div className={`  flex flex-wrap sm:flex-nowrap md:flex-nowrap gap-4 align-top items-baseline mb-2 `}>
                                                {
                                                    inputBoxes[key].map((item, indx) =>
                                                        item.type == ENUM_INPUT_TYPE.select ? (
                                                            <></>
                                                        ) : item.type == ENUM_INPUT_TYPE.autocomplete ? (
                                                            <>
                                                                <Autocomplete
                                                                    size="md"
                                                                    name={item.name}
                                                                    isInvalid={errors[item.name]}
                                                                    errorMessage={errors[item.name]}
                                                                    label={item?.placeholder}
                                                                    eventResizeFeature={true}
                                                                    selectionMode="single"
                                                                    showScrollIndicators={true}
                                                                    labelPlacement={"outside"}
                                                                    placeholder={item.placeholder}
                                                                    isRequired={item.isrequired}
                                                                    isLoading={isLoading}
                                                                    menuTrigger={"input"}
                                                                    className="max-w-23"
                                                                    classNames={{
                                                                        label: "text-xs text-black font-bold",
                                                                    }}
                                                                    isClearable={false}
                                                                    isVirtualized

                                                                    defaultItems={
                                                                        item.data ? item.data : []
                                                                    }
                                                                    onSelectionChange={(e) =>
                                                                        handleAutoCompleteChange(e, '', item.name)
                                                                    }
                                                                    variant="flat"
                                                                    color={item.id == formField.bookId ? "success" : item.id == formField.partyId ? "danger" : "warning"}
                                                                    //onChange={handleFormSelectionChange}
                                                                    selectedKey={formData[item.name]}

                                                                >
                                                                    {(list) => (
                                                                        <AutocompleteItem

                                                                            key={list[item.itemkey]}
                                                                        >
                                                                            {list[item.itemvalue]}
                                                                        </AutocompleteItem>
                                                                    )}
                                                                </Autocomplete>

                                                            </>
                                                        ) : item.type == ENUM_INPUT_TYPE.date ? (
                                                            <div className=" w-full flex items-center">
                                                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                                    <DatePicker
                                                                        label={item.placeholder}
                                                                        views={["day", "month", "year"]}
                                                                        format="DD/MM/YYYY"
                                                                        value={
                                                                            formData[item.name]
                                                                                ? dayjs(formData[item.name], "YYYY-MM-DD")
                                                                                : formData[item.name]
                                                                        }
                                                                        // minDate={minAllowedDate}
                                                                        // maxDate={maxAllowedDate}
                                                                        onChange={(newValue) => {
                                                                            setFormData((prev) => {
                                                                                return {
                                                                                    ...prev,
                                                                                    [item.name]: newValue != '' && newValue != 'Invalid Date' ?
                                                                                        dayjs(newValue).format("YYYY-MM-DD") : null,
                                                                                };
                                                                            });
                                                                        }}
                                                                        //isRequired={item.required}
                                                                        className="w-full "
                                                                        slotProps={{
                                                                            textField: {
                                                                                size: "small", error: errors[item.name], helperText: errors[item.name],
                                                                                onBlur: (e) => handleDateBlur(e, item.name),
                                                                            },
                                                                        }}
                                                                    />
                                                                </LocalizationProvider>
                                                            </div>
                                                        ) : item.type == ENUM_INPUT_TYPE.inputlist ? (
                                                            <>

                                                                <AutoCompleteInput
                                                                    label={item?.placeholder}
                                                                    value={formData[item.name]}
                                                                    name={item.name}
                                                                    options={item?.data || []}
                                                                    optionKey={item?.itemvalue}
                                                                    optionValue=""
                                                                    labelClass="text-slate-900"
                                                                    cssClass=""

                                                                    onChange={(val) =>
                                                                        setFormData(prev => ({ ...prev, [item?.name]: val }))
                                                                    }
                                                                    onSelect={(item) => {
                                                                        console.log("Selected:", item);
                                                                    }}
                                                                    onCreate={(newName) => {
                                                                        console.log("Create new:", newName);
                                                                        // call API here if needed
                                                                    }}
                                                                /></>) : (

                                                            <Input
                                                                type={item.type}
                                                                name={item.name}
                                                                id={item.name}
                                                                isInvalid={errors[item.name]}
                                                                errorMessage={errors[item.name]}
                                                                placeholder={item.placeholder}
                                                                label={item.placeholder}
                                                                labelPlacement="outside"
                                                                isRequired={item.isrequired}
                                                                value={formData[item.name]}
                                                                variant="bordered"
                                                                onChange={(e) => handleChange(e)}
                                                                onBlur={(e) => hanldeBlur("", e, item.name)}
                                                                size={"md"}
                                                                classNames={{
                                                                    //inputWrapper:"bg-red-700 h-1 px-2 m-0",
                                                                    label: "text-xs text-black font-bold",
                                                                }}
                                                            ></Input>
                                                        )
                                                    )
                                                }
                                            </div>
                                        </div>
                                    ))
                                }
                                <div className={` flex gap-4 item-center mb-2 `}>
                                    <Textarea
                                        type="text"
                                        name={formField.narration}
                                        placeholder={"Extra Narration"}
                                        label={"Extra Narration"}
                                        labelPlacement="outside"
                                        variant="bordered"
                                        classNames={{
                                            label: "text-xs text-black font-bold",
                                        }}
                                        value={formData[formField.narration]}
                                        size={"md"}
                                        onChange={handleChange}
                                    >

                                    </Textarea>
                                </div>
                            </Tab>
                            <Tab key="misc" title="Misc">
                                {
                                    Object.keys(miscInputBoxes).map((key, ind) => (
                                        <div key={`item-${ind}`}>
                                            {/* ${isMobile ? 'flex-wrap' : ''} */}
                                            <div className={`  flex flex-wrap sm:flex-nowrap md:flex-nowrap gap-4 align-top items-baseline mb-2 `}>
                                                {
                                                    miscInputBoxes[key].map((item, indx) =>
                                                        item.type == ENUM_INPUT_TYPE.select ? (
                                                            <></>
                                                        ) : item.type == ENUM_INPUT_TYPE.autocomplete ? (
                                                            <>
                                                                <Autocomplete
                                                                    size="md"
                                                                    name={item.name}
                                                                    isInvalid={errors[item.name]}
                                                                    errorMessage={errors[item.name]}
                                                                    label={item?.placeholder}
                                                                    eventResizeFeature={true}
                                                                    selectionMode="single"
                                                                    showScrollIndicators={true}
                                                                    labelPlacement={"outside"}
                                                                    placeholder={item.placeholder}
                                                                    isRequired={item.isrequired}
                                                                    isLoading={isLoading}
                                                                    menuTrigger={"input"}
                                                                    className="max-w-23"
                                                                    classNames={{
                                                                        label: "text-xs text-black font-bold",
                                                                    }}
                                                                    isClearable={false}
                                                                    isVirtualized

                                                                    defaultItems={
                                                                        item.data ? item.data : []
                                                                    }
                                                                    onSelectionChange={(e) =>
                                                                        handleAutoCompleteChange(e, '', item.name)
                                                                    }
                                                                    variant="flat"
                                                                    color={item.id == formField.bookId ? "success" : item.id == formField.partyId ? "danger" : "warning"}
                                                                    //onChange={handleFormSelectionChange}
                                                                    selectedKey={formData[item.name]}

                                                                >
                                                                    {(list) => (
                                                                        <AutocompleteItem

                                                                            key={list[item.itemkey]}
                                                                        >
                                                                            {list[item.itemvalue]}
                                                                        </AutocompleteItem>
                                                                    )}
                                                                </Autocomplete>

                                                            </>
                                                        ) : item.type == ENUM_INPUT_TYPE.date ? (
                                                            <div className=" w-full flex items-center">
                                                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                                    <DatePicker
                                                                        label={item.placeholder}
                                                                        views={["day", "month", "year"]}
                                                                        format="DD/MM/YYYY"
                                                                        value={
                                                                            formData[item.name]
                                                                                ? dayjs(formData[item.name], "YYYY-MM-DD")
                                                                                : formData[item.name]
                                                                        }
                                                                        //minDate={minAllowedDate}
                                                                        // maxDate={maxAllowedDate}
                                                                        onChange={(newValue) => {
                                                                            setFormData((prev) => {
                                                                                return {
                                                                                    ...prev,
                                                                                    [item.name]: newValue != '' && newValue != 'Invalid Date' ?
                                                                                        dayjs(newValue).format("YYYY-MM-DD") : null,
                                                                                };
                                                                            });
                                                                        }}
                                                                        //isRequired={item.required}
                                                                        className="w-full "
                                                                        slotProps={{
                                                                            textField: {
                                                                                size: "small", error: errors[item.name], helperText: errors[item.name],
                                                                                onBlur: (e) => handleDateBlur(e, item.name),
                                                                            },
                                                                        }}
                                                                    />
                                                                </LocalizationProvider>
                                                            </div>
                                                        ) : item.type == ENUM_INPUT_TYPE.inputlist ? (
                                                            <>

                                                                <AutoCompleteInput
                                                                    label={item?.placeholder}
                                                                    value={formData[item.name]}
                                                                    name={item.name}
                                                                    options={item?.data || []}
                                                                    optionKey={item?.itemvalue}
                                                                    optionValue=""
                                                                    labelClass="text-slate-900"
                                                                    cssClass=""

                                                                    onChange={(val) =>
                                                                        setFormData(prev => ({ ...prev, [item?.name]: val }))
                                                                    }
                                                                    onSelect={(item) => {
                                                                        console.log("Selected:", item);
                                                                    }}
                                                                    onCreate={(newName) => {
                                                                        console.log("Create new:", newName);
                                                                        // call API here if needed
                                                                    }}
                                                                /></>) : (

                                                            <Input
                                                                type={item.type}
                                                                name={item.name}
                                                                id={item.name}
                                                                isInvalid={errors[item.name]}
                                                                errorMessage={errors[item.name]}
                                                                placeholder={item.placeholder}
                                                                label={item.placeholder}
                                                                labelPlacement="outside"
                                                                isRequired={item.isrequired}
                                                                value={formData[item.name]}
                                                                variant="bordered"
                                                                onChange={(e) => handleChange(e)}
                                                                onBlur={(e) => hanldeBlur("", e, item.name)}
                                                                size={"md"}
                                                                classNames={{
                                                                    //inputWrapper:"bg-red-700 h-1 px-2 m-0",
                                                                    label: "text-xs text-black font-bold",
                                                                }}
                                                            ></Input>
                                                        )
                                                    )
                                                }
                                            </div>
                                        </div>
                                    ))
                                }
                            </Tab>
                        </Tabs>
                        <div className="justify-center flex items-center gap-4">
                            <Button
                                color="default"
                                type="submit"
                                size="sm"
                                variant="shadow"
                                isLoading={isPending}
                                className="bg-blue-600 text-white uppercase font-semibold"
                                //isDisabled={isDisableSubmit}
                                startContent={<FontAwesomeIcon icon={faSave} />}
                            >
                                Save Detail
                            </Button>



                        </div>
                    </form>

                </CardBody>
            </Card>
        </div>
    );
};

export default ExportDetailEntry;

